import { SetBranchesComponent } from './SetBranchesComponent.main';

export { SetBranchesComponent };
